import { render } from "./MmRegister.vue?vue&type=template&id=c45de48e"
import script from "./MmRegister.vue?vue&type=script&lang=js"
export * from "./MmRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__